import React from 'react';

export default props => {
	return <div className="common-ui-layout-action-row">{props.children}</div>;
};
